/**
 * 请求附加的参数处理，主要是header中的信息
 *
 * @file plugins/request.ts
 * @author yangwei(yangwei14@baidu.com)
 */

export default () => (req, next) => {
    // 增加 locale & _ 参数
    req.url += req.url.indexOf('?') > 0 ? '&' : '?';
    req.url += '&_=' + new Date();
    //  添加埋点统计的记录时间
    req.startTime = req.startTime || new Date().getTime();
    next();
};
